import React from 'react'
import AppInput from 'components/atoms/AppInput/AppInput'
import { TemplateTabs } from '../../molecules/TemplateTabs'
import { TemplateStatusFilter } from '../../molecules/TemplateStatusFilter'
import { TemplateOperationMode } from '../../../../domain/entities/Template'
import { TemplateStatus } from '../../../../domain/entities/TemplateStatus'
import AppDate from '../../../../../components/atoms/AppDate/AppDate'

interface TemplateFilterBarProps {
    activeTab: string
    activeStatus?: TemplateStatus
    totalAllTemplates: number
    totalByClassificationType: TemplateOperationMode[]
    onTabChange: (tabId: string) => void
    onStatusChange: (status?: TemplateStatus) => void
    onSearchChange: (name: string) => void
    onDateChange: (range: { start: Date | null; end: Date | null }) => void
}

export function TemplateFilterBar({
    activeTab,
    activeStatus,
    totalAllTemplates,
    totalByClassificationType,
    onTabChange,
    onStatusChange,
    onSearchChange,
    onDateChange,
}: TemplateFilterBarProps) {
    const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onSearchChange((e.target as HTMLInputElement).value)
        }
    }

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <TemplateTabs
                    activeTab={activeTab}
                    totalAllTemplates={totalAllTemplates}
                    totalByClassificationType={totalByClassificationType}
                    onTabChange={onTabChange}
                />
                <div className="pb-2">
                    <AppDate sendDate={onDateChange} />
                </div>
            </div>

            <div className="flex items-center justify-between mb-6 gap-4">
                <div className="w-full max-w-[350px]">
                    <AppInput
                        placeholder="Buscar"
                        onKeyDown={handleSearch}
                        showSearchIcon
                    />
                </div>
                <TemplateStatusFilter activeStatus={activeStatus} onStatusChange={onStatusChange} />
            </div>
        </div>
    )
}
